import {
  CHANGE_ACTIVE_NAV,
  CHANGE_ACTIVE_SCHOOL,
  REHYDRATE_NAV_DATA,
} from "./navmode.type";

export const changeActiveNav = (mode: string) => ({
  type: CHANGE_ACTIVE_NAV,
  payload: {
    mode,
  },
});

export const changeActiveSchool = (school: object) => ({
  type: CHANGE_ACTIVE_SCHOOL,
  payload: {
    school,
  },
});

export const rehydrateNavData = () => ({
  type: REHYDRATE_NAV_DATA,
});
